module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CmsTemplate', {
    attrs: {
      "pageName": 'companies',
      "pageTitle": _vm.$t('commons.companies')
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 pull-right"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('content.byFocus')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.focus),
      expression: "focus"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.focus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.applyFilters]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('content.selectFocus')))]), _vm._v(" "), _c('option', [_vm._v("Aeronáutico")]), _vm._v(" "), _c('option', [_vm._v("Agronegócio")]), _vm._v(" "), _c('option', [_vm._v("Alimentos")]), _vm._v(" "), _c('option', [_vm._v("Economia criativa")]), _vm._v(" "), _c('option', [_vm._v("Eletrônica")]), _vm._v(" "), _c('option', [_vm._v("Energia")]), _vm._v(" "), _c('option', [_vm._v("Espacial")]), _vm._v(" "), _c('option', [_vm._v("Meio ambiente")]), _vm._v(" "), _c('option', [_vm._v("Mineral")]), _vm._v(" "), _c('option', [_vm._v("Petróleo e gás natural")]), _vm._v(" "), _c('option', [_vm._v("Química")]), _vm._v(" "), _c('option', [_vm._v("Recursos hídricos")]), _vm._v(" "), _c('option', [_vm._v("Saúde animal")]), _vm._v(" "), _c('option', [_vm._v("Saúde humana")]), _vm._v(" "), _c('option', [_vm._v("Tecnologia da informação")]), _vm._v(" "), _c('option', [_vm._v("Telecomunicações")]), _vm._v(" "), _c('option', [_vm._v("Transporte aquaviario e construção naval")]), _vm._v(" "), _c('option', [_vm._v("Transporte terrestre e hidroviário")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t("commons.companies")))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('DataTables', {
    attrs: {
      "tableId": "parks-table",
      "url": this.getApiUrl(),
      "columns": this.columns,
      "columnDefs": this.columnDefs,
      "order": [
        [1, 'asc']
      ]
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5031864e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/CompaniesPage.vue
// module id = 668
// module chunks = 1